import React from 'react';
import './AndroidAppDevelopment.css';
import { Helmet } from "react-helmet-async";
const features = [
    "Kotlin & Java Development",
    "Custom UI/UX for Android",
    "Google Play Store Deployment",
    "Tablet & Device Compatibility",
    "Firebase & Google API Integration",
    "Push Notifications & In-App Purchases",
    "Offline Mode & Local Storage",
    "Automated Testing & QA"
];

const benefits = [
    "Wider User Base & Global Reach",
    "Faster Time to Market",
    "Flexible Customization Options",
    "Cost-Effective Development",
    "Open-Source Ecosystem",
    "Strong Google Support",
    "Seamless Backend Integration",
    "Post-Launch Maintenance"
];

const industries = [
    "Healthcare",
    "Retail & eCommerce",
    "Banking & Finance",
    "Education",
    "Transportation & Logistics",
    "Media & Entertainment",
    "Real Estate",
    "Food Delivery"
];

const AndroidAppDevelopment = () => {
    return (
        <div className="android-container">
            <Helmet>
  <title>Android App Development Services | APTech Solution</title>
  <meta 
    name="description" 
    content="We build scalable and user-friendly Android apps tailored for startups and enterprises with end-to-end development support." 
  />
</Helmet>

            <h1 className="android-title">Android App Development</h1>
            <p className="android-subtitle">
                Build powerful, flexible, and user-friendly Android apps for phones, tablets, and everything in between — tailored to your business goals.
            </p>

            <section className="android-section">
                <h2 className="section-heading">Why Choose Android?</h2>
                <p className="android-paragraph">
                    Android powers over 70% of global mobile devices. Its open-source nature, customization flexibility, and wide device reach make it the go-to choice for businesses aiming to scale fast.
                </p>
            </section>

            <section className="android-section">
                <h2 className="section-heading">Core Features</h2>
                <div className="card-grid">
                    {features.map((feature, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🤖</span>
                            <p>{feature}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="android-section">
                <h2 className="section-heading">Industries We Serve</h2>
                <div className="card-grid">
                    {industries.map((industry, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🏢</span>
                            <p>{industry}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="android-section">
                <h2 className="section-heading">Benefits of Android Apps</h2>
                <div className="card-grid">
                    {benefits.map((benefit, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🚀</span>
                            <p>{benefit}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="cta-box">
                <h3>Let’s Build Your Android App</h3>
                <p>From MVP to full-scale app — we develop Android apps that deliver results. Let's turn your idea into a real product.</p>
                <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                    <button className="cta-button">Start Your Project</button>
                </a>
               
            </section>
        </div>
    );
};

export default AndroidAppDevelopment;
